import {NodeRecord, SensorRecord} from './sensorRecord.model';
import {VideoResource} from './videoResource.model';
import {Comment} from './comment.model';

export class SensorRecordChartModel {
  comments: Comment[];
  sensorRecords: SensorRecord[];
  videoResources: VideoResource[];
}

export class NodeRecordChartModel {
  nodeRecords: NodeRecord[];
  videoResources: VideoResource[];
}
